import { AppThunkAction } from 'models/Store';

import { getlocationsWorkCentre } from '../collectionPoint/collectionPoint.thunks';
import { selectShipment } from '../shipment/shipment.selectors';
import { selectCurrentArticleIndex } from './consignmentSwitcher.selectors';
import { setCurrentArticleIndex } from './consignmentSwitcher.slice';

export const nextArticle =
  (articleSize: number): AppThunkAction =>
  (dispatch, getState) => {
    const state = getState();
    const currentArticleIndex = selectCurrentArticleIndex(state);

    if (!articleSize || articleSize === 1) return;
    const newArticleIndex = currentArticleIndex + 1;
    if (newArticleIndex < articleSize) {
      dispatch(updateCurrentArticleIndex(newArticleIndex));
    } else {
      dispatch(updateCurrentArticleIndex(0));
    }
  };

export const previousArticle =
  (articleSize: number): AppThunkAction =>
  (dispatch, getState) => {
    const state = getState();
    const currentArticleIndex = selectCurrentArticleIndex(state);

    if (!articleSize || articleSize === 1) return;
    if (currentArticleIndex > 0) {
      dispatch(updateCurrentArticleIndex(currentArticleIndex - 1));
    } else {
      dispatch(updateCurrentArticleIndex(articleSize - 1));
    }
  };

export const updateCurrentArticleIndex =
  (index: number): AppThunkAction =>
  (dispatch, getState) => {
    const state = getState();
    const shipment = selectShipment(state);
    if (shipment?.articles?.length) {
      const latestEventWcid = shipment.articles[index]?.events?.[0]?.toWcid ?? null;
      if (latestEventWcid) dispatch(getlocationsWorkCentre(latestEventWcid));
    }
    dispatch(setCurrentArticleIndex(index));
  };
